const PlaylistTrack = (props) => {
  const {
    mix,
    mixesData,
    setDrawerMix,
    setDrawerOpen,
    setPlayingMix,
    setPlayerOpen,
  } = props;

  
  const mixFromData = mixesData.find((item) => item.title === mix.title);

  return (
    <div
      className="playlist__mix-wrapper"
      onClick={(e) => {
        setDrawerMix(mixFromData);
        setDrawerOpen(true);
      }}
    >
      <div className="playlist__mix-title">{mix.title}</div>
      <div className="playlist__mix-buttons">
        <button
          className={`ra__button playlist__more-info`}
          onClick={(e) => {
            setDrawerMix(mixFromData);
            setDrawerOpen(true);
          }}
        >
          More Info <span className="ra__arrow">&#8599;</span>
        </button>
        <button
          className="ra__button playlist__listen"
          onClick={(e) => {
            e.stopPropagation();
            setPlayingMix(mixFromData);
            setPlayerOpen(true);
          }}
        >
          Listen
        </button>
      </div>
    </div>
  );
};

export default PlaylistTrack;
